import { FormikProps } from 'formik';
import * as React from 'react';
import VoxelCheckbox from '../../../../../../../../voxel/Forms/VoxelCheckbox';
import VoxelInput from '../../../../../../../../voxel/Forms/VoxelInput';
import { ComboRequestGq } from '../../../../../../../../../graphql/projects/models/ComboRequestGq';
import { ComboFormState } from '../models/ComboFormState';

export interface ComboSearchSettingsProps {
  comboRequest: ComboRequestGq;
  formBag: FormikProps<ComboFormState>;
}

const ComboSearchSettings: React.FC<ComboSearchSettingsProps> = ({ comboRequest, formBag }) => {
  return (
    <>
      <div className="w-full flex flex-row flex-wrap lg:flex-nowrap gap-8 justify-start items-end">
        <div className="basis-full lg:basis-1/3">
          <VoxelInput
            autoFocus
            id="title"
            label="Title (optional)"
            labelPosition="top"
            placeholder="Optional search title"
            value={formBag.values.name}
            onChange={(event) => formBag.setFieldValue('name', event.target.value)}
            deleteValue={() => formBag.setFieldValue('name', '')}
            helperText={''}
            showHelperText={false}
            disabled={!!comboRequest.processingStartTime}
          />
        </div>
        <div className="basis-auto lg:basis-2/3 flex flex-row gap-8 items-end">
          <div className="py-1 w-full">
            <VoxelCheckbox
              label={'Include zero volume keywords'}
              color="slate"
              padding
              checked={formBag.values.includeZeroVolume}
              onChange={(value: boolean) => formBag.setFieldValue('includeZeroVolume', value)}
              disabled={!!comboRequest.processingStartTime}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default ComboSearchSettings;
